module.exports = __webpack_public_path__ + "static/img/logo.67d34b0d.png";